import { render, staticRenderFns } from "./account_page.vue?vue&type=template&id=9834dc90&"
import script from "./account_page.vue?vue&type=script&lang=js&"
export * from "./account_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports